import React, { useState, useEffect, useRef } from 'react'; 
import { Link, useNavigate } from 'react-router-dom'; 
import { auth } from '../../Components/LoginComp/firebase'; 
import { FaUserCircle, FaCaretDown, FaBars, FaTimes } from 'react-icons/fa'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faUser, faFile, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'; 
import './nav.css';

function NavComp() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showAboutDropdown, setShowAboutDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const aboutDropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsLoggedIn(!!user);
    });
    return () => unsubscribe();
  }, []);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
      if (aboutDropdownRef.current && !aboutDropdownRef.current.contains(event.target)) {
        setShowAboutDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setIsLoggedIn(false);
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const toggleUserDropdown = () => {
    setShowDropdown(!showDropdown);
    setShowAboutDropdown(false); // Close other dropdown
  };

  const toggleAboutDropdown = () => {
    setShowAboutDropdown(!showAboutDropdown);
    setShowDropdown(false); // Close other dropdown
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/">
          <img src="/logo_ehipassiko.png" alt="EHIPASSIKO" className="logo" />
        </Link>
      </div>
      <button className="menu-toggle" onClick={toggleMenu}>
        {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
      </button>
      <ul className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
        <li><Link to="/" onClick={closeMenu}>Home</Link></li>
        <li><Link to="/appointment" onClick={closeMenu}>Appointment</Link></li>
        <li><Link to="/arama-poojava" onClick={closeMenu}>Arama Pooja</Link></li>
        <li><Link to="/gallery" onClick={closeMenu}>Gallery</Link></li>
        <li><Link to="/event" onClick={closeMenu}>Events</Link></li>
        <li><Link to="/dhammapada" onClick={closeMenu}>Dhamma Pada</Link></li>




        <li>
          <a href="#" className="dropdown-link" onClick={(e) => e.stopPropagation()}>About Us</a>
          <ul className={`dropdown-menu ${showAboutDropdown ? 'show' : ''}`}>
            <li><Link to="/aboutus" onClick={closeMenu}>About Us</Link></li>
            <li><Link to="/contactus" onClick={closeMenu}>Contact Us</Link></li>
            <li><Link to="/sangaprofile" onClick={closeMenu}>Sanga Profile</Link></li>
          </ul>
        </li>
 

        {!isLoggedIn && (
          <li className="auth-buttons">
            <Link to="/signin" onClick={closeMenu}>
              <button className="navbar-btn">Sign In</button>
            </Link>
            <Link to="/signup" onClick={closeMenu}>
              <button className="navbar-btn">Sign Up</button>
            </Link>
          </li>
        )}
      </ul>




            


      
      <div className="navbar-buttons">
        {isLoggedIn && (
          <div className="user-menu-container" ref={dropdownRef}>
            <button className="user-icon" onClick={toggleUserDropdown}>
              <FaUserCircle size={24} /> <FaCaretDown size={16} />
            </button>
            {showDropdown && (
              <ul className="user-dropdown">
                <li>
                  <Link to="/userprofile" onClick={closeMenu}>
                    <FontAwesomeIcon icon={faUser} className="me-2" /> My Profile
                  </Link>
                </li>
                <li>
                  <Link to="/almsoffering" onClick={closeMenu}>
                    <FontAwesomeIcon icon={faFile} className="me-2" /> View My Alms Offering
                  </Link>
                </li>
                <li>
                  <Link to="/monastery" onClick={closeMenu}>
                    <FontAwesomeIcon icon={faFile} className="me-2" /> View My Monestery Offering
                  </Link>
                </li>
                <li>
                  <button onClick={() => {
                    closeMenu();
                    handleLogout();
                  }}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Log Out
                  </button>
                </li>
              </ul>
            )}
          </div>
        )}
      </div>
    </nav>
  );
}

export default NavComp;